import { authHeader, isTokenExpired } from "../helpers";

export const crmService = {
  getCrm,
  createCrm,
  updateCrm,
  uploadReference,
  getReference,
  deleteReference,
  createTag,
  searchTag,
  searchAllTags,
  getCrmDesign,
  searchCrm,
  createLink,
  deleteLink,
  downloadReferencesFolder,
};

function getCrm(myDesignId, targetId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/my-design/${myDesignId}/target/${targetId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createCrm(myDesignId, targetId, data) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/my-design/${myDesignId}/target/${targetId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateCrm(data) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${data._id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadReference(crmId, reference, title) {
  const toSend = new FormData();
  toSend.append("file", reference);
  toSend.append("title", title);

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: toSend,
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${crmId}/reference`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getReference(crmId, refId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${crmId}/reference/${refId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.blob();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function downloadReferencesFolder(crmId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${crmId}/references-download`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.blob();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteReference(crmId, refId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${crmId}/reference/${refId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createTag(type, tag) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify({
      name: tag,
      type: type,
    }),
  };

  return fetch(`${process.env.REACT_APP_GATEWAY_URL}/crm-tags`, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function searchTag(tagName, tagType) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm-tags/search?name=${tagName}&type=${tagType}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function searchAllTags(tagName) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm-tags/search?name=${tagName}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getCrmDesign(myDesignId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/my-design/${myDesignId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function searchCrm(filterParams) {
  let stringParams = "search?";

  const keys = Object.keys(filterParams);
  const values = Object.values(filterParams);
  let indexesIndex = 0;
  const indexesTab = [];

  values.forEach((item, index) => {
    if (item.length === 0) {
      indexesTab[indexesIndex] = index;
      indexesIndex++;
    }
  });

  for (let i = indexesIndex - 1; i >= 0; i--) {
    keys.splice(indexesTab[i], 1);
    values.splice(indexesTab[i], 1);
  }

  values.forEach((item, index) => {
    if (index > 0) stringParams += "&";
    if (typeof item === "string" || typeof item == "boolean")
      stringParams += `${keys[index]}=${item}`;
    else {
      item.forEach((tag, tagIndex) => {
        if (tagIndex > 0) stringParams += "&";
        stringParams += `${keys[index]}=${tag.id}`;
      });
    }
  });
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${stringParams}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createLink(crmId, link, title) {
  const toSend = new FormData();
  toSend.append("link", link);
  toSend.append("title", title);

  const requestOptions = {
    method: "POST",
    headers: authHeader(true),
    body: toSend,
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${crmId}/link`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteLink(crmId, linkId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/crm/${crmId}/link/${linkId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
